<template>
  <section class="main-content" v-if="page">
  <MainBanner :banner="slug" />
  <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Impressum",
        "item": "https://ito-consult.de/p/{{slug}}"
      }]
    }
  </script>
    <section class="block-content mb-5">
        <div class="container my-5 py-5">
            <div id="landingpage">
                <h2>{{page.title}}</h2>
                <article class="d-content" v-html="page.content"></article>
            </div>
        </div>
    </section>
    <section class="block-content mb-5" v-if="page.video">
      <div class="container my-5 py-5">
        <video autoplay muted loop playsinline autobuffer>
            <source  :src="page.video.file.data.full_url" type="video/mp4">
        </video>
      </div>
    </section>
    <section class="block-content"  data-aos="fade-up" data-aos-duration="1500" data-aos-offset="0" v-if="page.gallery">
        <div class="container my-md-5 py-md-5">
            <h2>{{page.gallery_title}}</h2>
            <div class="images-wrapper row my-5">
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3"
                v-for="(image, imageIndex) in page.gallery"
                :key="imageIndex"
                @click="index = imageIndex">
                <div class="event-image">
                  <img width="500" heigth="350" class="img-fluid" :src="'https://cdn.ito-consult.de/itoconsult/assets/' + image.directus_files_id.private_hash + '?w=500&h=350&f=crop&q=30'" :title="image.title" :alt="image.title" />
                </div>
              </div>
            </div>
            <p class="text-muted small text-center" v-if="page.gallery_footer">{{page.gallery_footer}}</p>
          </div>
    </section>
    <CoolLightBox
            v-if="gallery_images"
            :items="gallery_images"
            :index="index"
            @close="index = null">
    </CoolLightBox>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Landingpage',
  data: function () {
    return {
      page: null,
      index: null
    }
  },
  metaInfo () {
    if (this.page) {
      return {
        title: this.page.meta_title,
        meta: [
          { name: 'description', content: this.page.description },
          { property: 'og:title', content: this.page.meta_title },
          { property: 'og:description', content: this.page.description }
        ]
      }
    }
  },
  computed: {
    slug: function () {
      return this.$route.params.id
    },
    gallery_images () {
      var iarray = []
      this.page.gallery.forEach(function (i) {
        iarray.push(i.directus_files_id.data.full_url)
      })
      return iarray
    }
  },
  components: {
    MainBanner,
    CoolLightBox
  },
  mounted () {
    axios.get('/landingpages?fields=*.*,gallery.*.*,&filter[slug]=' + this.slug)
      .then(response => {
        if (response.data.data.length) {
          this.page = response.data.data[0]
          store.commit('loadingStatus', false)
        } else {
          this.$router.push({ name: '404' })
        }
      })
  },
  methods: {
    getThumbURL (hash) {
      return 'https://cdn.ito-consult.de/itoconsult/assets/' + hash + '?w=500&h=350&f=crop&q=30'
    }
  }
}
</script>
<style scoped>
 .event-image {filter: grayscale(1); overflow: hidden;}
 .event-image img {transition: all 500ms;}
 .event-image:hover {filter: grayscale(0);}
 .event-image:hover img {transform: scale(1.1,1.1);}
</style>
